/**
 * Utility to detect if running in Electron environment
 */

export const isElectron = () => {
  return !!window.electronAPI?.isElectron;
};

export const getPlatform = () => {
  return window.electronAPI?.platform || "web";
};

export const getElectronProxyUrl = () => {
  return window.electronAPI?.proxyUrl || null;
};
